import Sentry from '@integrations/Sentry';
import React from 'react';

import ErrorComponent from './ErrorComponent';

class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: null,
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error: error,
    };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    const { hasError, error } = this.state;

    if (hasError) {
      return (
        <ErrorComponent title="Sorry, something went wrong." error={error}>
          <p>We&apos;ve been notified and we&apos;re been working on it.</p>
        </ErrorComponent>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
